import * as types from './mutations_types.js'
// import {app} from '../main'

// 為了設定語系引入 i18n
// import {app} from '../main'
// import i18n from '../main.js'

export const state = {
  user2: false,
  inputData: null,
  loadCount: 0,
  loading: false,
  lang: localStorage.lang || 'tw',
  reSetFg: false,
  reSetFg2: false,
  size: 0,
  user: {
    iD: '',
    name: '匿名者',
    type: '',
    status: '4',
    loginTime: new Date(),
    isInit: false,
    mode: ''
  },
  prevUserInfos: {},
  appId: -1,
  pageId: -1
}

export const actions = {
  toggleLoading ({ commit }, isLoading) {
    commit(types.LOADING, isLoading)
  },
  // login
  actionLogin ({ commit }, user) {
    commit(types.USER, user) // success 儲存 token
  },
  actionLogin2 ({ commit }, user2) {
    commit(types.USER2, user2) // success 儲存 token
  },
  actionLogin2Data ({ commit }, inputData) {
    commit(types.INPUTDATA, inputData) // success 儲存 token
  },
  resetLogin ({ commit }) {
    // console.log('1. reset Login')
    commit(types.CLEARUSER)
    commit(types.RESETID)
  },
  setLanguage ({ commit }, lang) {
    commit(types.LANGUAGE, lang)
  },
  setSize ({ commit }, size) {
    commit(types.SIZE, size)
  },
  actionIncrease ({ commit }) {
    commit(types.INCREASE)
  },
  actionDecrease ({ commit }) {
    commit(types.DECREASE)
  },
  actionResetCount ({ commit }) {
    commit(types.RESETCOUNT)
  },
  actionAppId ({ commit }, id) {
    commit(types.APPID, id)
  },
  actionPageId ({ commit }, id) {
    commit(types.PAGEID, id)
  },
  actionReSetFlag ({ commit }, id) {
    commit(types.RESETFLAG, id)
  },
  actionReSetFlag2 ({ commit }, id) {
    commit(types.RESETFLAG2, id)
  },
  actionResetId ({ commit }) {
    commit(types.RESETID)
  },
  // Switch user
  switchUser ({ commit }) {
    commit(types.SWITCH)
  },
  // Reset user
  resetUser ({ commit }) {
    commit(types.RESETUSER)
  }
}

export const mutations = {
  [types.LOADING] (state, isLoading) {
    state.loading = isLoading
  },
  [types.USER] (state, user) {
    // console.log('set USER')
    state.user = user
  },
  [types.USER2] (state, user2) {
    // console.log('set USER2')
    state.user2 = user2
  },
  [types.INPUTDATA] (state, inputData) {
    // console.log('set inputData')
    state.inputData = inputData
  },
  [types.CLEARUSER] (state) {
    // console.log('CLEAR USER')
    state.user = {
      iD: '',
      name: '匿名者',
      type: '',
      status: '4',
      loginTime: new Date(),
      isInit: false
    }
  },
  [types.LANGUAGE] (state, setlang) {
    state.lang = setlang
    // 設定 Vue config 將會改變使用的語系
    // i18n.locale = state.lang
    // app.$i18n.locale = setlang
    localStorage.setItem('lang', setlang)
  },
  [types.SIZE] (state, setsize) {
    state.size = setsize
  },
  [types.INCREASE] (state, user) {
    state.loadCount++
  },
  [types.DECREASE] (state, user) {
    if (state.loadCount > 0) {
      state.loadCount--
    }
  },
  [types.RESETCOUNT] (state, user) {
    state.loadCount = 0
  },
  [types.APPID] (state, id) {
    state.appId = id
  },
  [types.PAGEID] (state, id) {
    state.pageId = id
  },
  [types.RESETFLAG] (state, id) {
    state.reSetFg = id
  },
  [types.RESETFLAG2] (state, id) {
    state.reSetFg2 = id
  },
  [types.RESETID] (state, id) {
    state.appId = -1
    state.pageId = -1
  },
  [types.SWITCH] (state) {
    console.log('set SWITCH')
    state.prevUserInfos = JSON.parse(JSON.stringify(state.user))
  },
  [types.RESETUSER] (state) {
    console.log('set RESETUSER')
    state.user = JSON.parse(JSON.stringify(state.prevUserInfos))
    state.prevUserInfos = {}
  }
}
